import { IDataLayer, ISoilService } from "../../types"
import { AnalysisLayer, IAnalysisLayerData } from "./map/analysis-layer"
import { AnalysisType } from "./types"
import { GlobalAnalysisVM } from "./viewmodel/analysis-vm"

export enum AllocationHistoryAction {
    Allocate,
    Unallocate
}

export interface IAllocationHistory {
    action: AllocationHistoryAction;
    analysis: GlobalAnalysisVM;
    layerData: IAnalysisLayerData;
}

export class MapAllocationContext {

    constructor(public readonly svc: ISoilService, public readonly soilAnalysisLayers: IDataLayer[], public readonly soilTypeLayers: IDataLayer[]) {
        this.allocationHistory = [];
    }

    public analysisType: AnalysisType;
    public selectedAnalysis: GlobalAnalysisVM;
    public analysis: GlobalAnalysisVM[];
    public analysisLayer: AnalysisLayer;

    public allocationHistory: IAllocationHistory[];

    public updatingSelection: boolean;

    public showOnlyFields: boolean;

    public refreshFeatureSelection: (data: IAnalysisLayerData) => void;
    public refreshFeatures: (datas: IAnalysisLayerData[]) => void;
    public setupLayers: () => void;

    get layerOpacity(): number {
        return this.analysisLayer ? this.analysisLayer.opacity : 100;
    }

    set layerOpacity(value: number) {
        if (this.analysisLayer) {
            this.analysisLayer.opacity = value;
        }
    }

}
